import { __rest as t } from "tslib";
import a from "classnames";
import * as e from "react";
import { classNameModifier as i, classNameModifierByFlag as s } from "../shared/utils.js";
import { ComponentClassNames as o } from "../shared/constants.js";
import { Flex as r } from "../Flex/Flex.js";
import { Loader as l } from "../Loader/Loader.js";
import { View as n } from "../View/View.js";
var d = e.forwardRef(function (d, m) {
  var p = d.className,
      u = d.children,
      _d$isFullWidth = d.isFullWidth,
      c = _d$isFullWidth === void 0 ? !1 : _d$isFullWidth,
      f = d.isDisabled,
      b = d.isLoading,
      _d$loadingText = d.loadingText,
      h = _d$loadingText === void 0 ? "" : _d$loadingText,
      B = d.size,
      _d$type = d.type,
      g = _d$type === void 0 ? "button" : _d$type,
      j = d.variation,
      w = t(d, ["className", "children", "isFullWidth", "isDisabled", "isLoading", "loadingText", "size", "type", "variation"]);
  var x = a(o.Button, o.FieldGroupControl, i(o.Button, j), i(o.Button, B), s(o.Button, "disabled", f || b || w.disabled), s(o.Button, "loading", b), s(o.Button, "fullwidth", c), p);
  return e.createElement(n, Object.assign({
    ref: m,
    as: "button",
    className: x,
    "data-fullwidth": c,
    "data-loading": b,
    "data-size": B,
    "data-variation": j,
    isDisabled: f || b,
    type: g
  }, w), b && h ? e.createElement(r, {
    as: "span",
    className: o.ButtonLoaderWrapper
  }, e.createElement(l, {
    size: B
  }), h) : u);
});
d.displayName = "Button";
export { d as Button };